import {
  drawPointsAnim,
  drawAngleAnim,
  drawLineAnim,
  drawCircleAnim,
  moveAllPointAnim,
} from "../../../../../../src/animation/Circle/helpers/drawHelpers";

import {
  showCalcLine,
  drawAnglrOscilAnim,
  showSuppleAngleLine
} from "./helpers/drawHeplers";

import { ANGLE_NAMES_FOR_ANIM, POINT_DEGREES } from "../../types/Config";
import BasePointManager from "../../../../../../src/managers/BasePointManager";
import { ContextType } from "../../types/Interface";



export async function runCircleAnimation(context: ContextType, onComp: () => void) {
  const {
    circle,
    LineManager,
    PointManager,
    AngleManager,
    SupplAngleManager,
    CalcLineManager,
    cCoord,
  } = context;

  const [cSide1Point, cSide2Point, cSide3Point, cSide4Point] = PointManager.getRedPointsCoord();
  const RedPoints = PointManager.getRedPoints();
  const circlePoint = PointManager.getPoints()[0];
  const radians = PointManager.getRadians();
  const angles = AngleManager.getAngles();

  circle.setRadians([POINT_DEGREES[0], POINT_DEGREES[0]])

  await drawPointsAnim([circlePoint]);
  await drawCircleAnim(circle, POINT_DEGREES[0] + Math.PI * 2, 0, true, cCoord);

  await drawLineAnim(LineManager.lines[0], cSide1Point, cSide2Point);
  await drawLineAnim(LineManager.lines[1], cSide2Point, cSide3Point);
  await drawLineAnim(LineManager.lines[2], cSide3Point, cSide4Point);
  await drawLineAnim(LineManager.lines[3], cSide4Point, cSide1Point);

  drawAngleAnim(angles[0], ANGLE_NAMES_FOR_ANIM.angle1);
  await drawAngleAnim(angles[2], ANGLE_NAMES_FOR_ANIM.angle3);
  showCalcLine(CalcLineManager.firstCalcLine);

  drawAngleAnim(angles[1], ANGLE_NAMES_FOR_ANIM.angle2);
  await drawAngleAnim(angles[3], ANGLE_NAMES_FOR_ANIM.angle4);
  showCalcLine(CalcLineManager.secondCalcLine);

  await drawPointsAnim(RedPoints);

  for (let index = 0; index < 2; index++) {
    drawAnglrOscilAnim(radians[index], (radian) => PointManager.setRadian([{ pTag: RedPoints[index].tag, radian }]));
    await drawAnglrOscilAnim(radians[index + 2], (radian) => PointManager.setRadian([{ pTag: RedPoints[index + 2].tag, radian }]));
  }

  const pointAnimArr = [
    [-(2 * Math.PI) * 15 / 36, -(2 * Math.PI) * 3 / 36, -(2 * Math.PI) * 7 / 36, -(2 * Math.PI) * 10 / 36],
    [(2 * Math.PI) * 10.5 / 36, (2 * Math.PI) * 6 / 36, (2 * Math.PI) * 3.5 / 36, (2 * Math.PI) * 17 / 36],
    PointManager.getInitialRadians()
  ]

  for (let index = 0; index < pointAnimArr.length; index++) {
    const arr = pointAnimArr[index];
    await moveAllPointAnim(radians, arr, (radian, index) => PointManager.setRadian([{ pTag: RedPoints[index].tag, radian }]))
  }

  showSuppleAngleLine(SupplAngleManager.SupplAngleLines[0]);
  showSuppleAngleLine(SupplAngleManager.SupplAngleLines[1]);

  onComp();
}

export function runShapeAnimation(PointManager:BasePointManager, radians:number[], newRadians:number[]) {
  const RedPoints = PointManager.getRedPoints();
  moveAllPointAnim(radians, newRadians, (radian, index) => PointManager.setRadian([{ pTag: RedPoints[index].tag, radian }]))
}